


import React, { Component } from "react";

import { connect } from 'react-redux';
import DashboardSuperAdmin from './DashboardSuperAdmin';
import DashboardCompanyAdmin from './DashboardCompanyAdmin';


class DashboardPage extends Component {
	constructor(props){
    	super(props);
    	this.state = {
    		adminType:''
    	}
	}

	componentWillReceiveProps(nextProps) {
		
		if (nextProps.adminType){
			this.setState({'adminType':nextProps.adminType});
		}
	}
	render(){

		return(
			<div className="content">
				{
					this.props.adminType && this.props.adminType === 'admin' &&
					<DashboardSuperAdmin />
				}
				{
					this.props.adminType && this.props.adminType === 'company' &&
					<DashboardCompanyAdmin />
				}
			
			</div>
		);
	};
}


function mapStateToProps(state) {
    const { adminType } = state.adminReducer;

    return {
        adminType
    };
}

const Dashboard = connect(mapStateToProps)(DashboardPage);


export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Admin/Dashboard.jsx